import {createAsyncAction} from '../services/redux-toolkit'
import {reloadEvents} from './events'
import {setVeloCategoryFilter} from './velo-overrides'

export const selectCategory = createAsyncAction<void, string | null>(
  'SELECT_CATEGORY',
  async (categoryId, {dispatch}) => {
    dispatch(setVeloCategoryFilter(categoryId))
    dispatch(reloadEvents())
  },
)
